"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _actionButton = _interopRequireDefault(require("../actionButton/actionButton.presenter"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ButtonGroup = function ButtonGroup(_ref) {
  var buttons = _ref.buttons,
    isSmall = _ref.isSmall,
    areAllDisabled = _ref.areAllDisabled,
    color = _ref.color,
    groupUniqueID = _ref.uniqueID;
  return _react.default.createElement("div", {
    className: "agillicButtonGroup",
    "data-testid": groupUniqueID
  }, buttons.map(function (_ref2) {
    var isDisabled = _ref2.isDisabled,
      label = _ref2.label,
      tooltip = _ref2.tooltip,
      uniqueID = _ref2.uniqueID,
      isOn = _ref2.isOn,
      onToggle = _ref2.onToggle;
    return _react.default.createElement(_actionButton.default, {
      key: uniqueID,
      isSmall: isSmall,
      isDisabled: isDisabled || areAllDisabled,
      label: label,
      isOn: isOn,
      onClick: onToggle,
      uniqueID: uniqueID,
      tooltip: tooltip,
      color: color
    }, label);
  }));
};
ButtonGroup.propTypes = {
  buttons: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    uniqueID: _propTypes.string.isRequired,
    isOn: _propTypes.bool.isRequired,
    isDisabled: _propTypes.bool,
    onToggle: _propTypes.func.isRequired,
    label: _propTypes.string,
    tooltip: _propTypes.string
  })).isRequired,
  isSmall: _propTypes.bool,
  areAllDisabled: _propTypes.bool,
  color: (0, _propTypes.oneOf)(['grey', 'red', 'green', 'lightGreen', 'blue', 'orange', 'darkOrange', 'purple', 'yellow']).isRequired,
  uniqueID: _propTypes.string
};
ButtonGroup.defaultProps = {
  color: 'grey'
};
var _default = ButtonGroup;
exports.default = _default;